import React, { useEffect, useRef, useState } from 'react';
import '../../index.css';

const BlinkingImage = ({ imageSrc, audioSrc }) => {
    const [isBlinking, setIsBlinking] = useState(false);
    const audioRef = useRef(null);
    const audioContextRef = useRef(null);
    const analyserRef = useRef(null);

    useEffect(() => {
        let audioContext = audioContextRef.current;
        let analyser = analyserRef.current;

        if (!audioContext) {
            audioContext = new AudioContext();
            audioContextRef.current = audioContext;
        }

        const audioElement = audioRef.current;
        audioElement.volume = 0.1;

        if (!analyser) {
            analyser = audioContext.createAnalyser();
            analyser.fftSize = 256;
            analyserRef.current = analyser;
        }

        const audioSrcNode = audioContext.createMediaElementSource(audioElement);

        const interval = setInterval(() => {
            const frequencyBinCount = analyser.frequencyBinCount;
            const dataArray = new Uint8Array(frequencyBinCount);

            analyser.getByteFrequencyData(dataArray);
            const highFreqData = dataArray.slice(0, 5);
            const avg =
                highFreqData.reduce((a, b) => a + b, 0) / highFreqData.length;
            const max = 255;
            const normalizedAvg = avg / max;
            console.log(normalizedAvg);
            setIsBlinking(normalizedAvg > 0.60);
        }, 0.05);

        audioSrcNode.connect(analyser);
        analyser.connect(audioContext.destination);

        return () => {
            clearInterval(interval);
            audioSrcNode.disconnect();
            analyser.disconnect();
        };
    }, []); // Empty dependency array ensures this effect runs only once, on component mount

    return (
        <div>
            <img
                src={imageSrc}
                className="center"
                style={{ opacity: isBlinking ? 0 : 1 }}
                alt=""
            />
            <audio ref={audioRef} className="left" src={audioSrc} controls />
        </div>
    );
};

export default BlinkingImage;
